export const query = `query getCaseStudies($site: [String] = "default", $industry: [QueryArgument] = "*", $platforms: [QueryArgument] = "*", $region: [QueryArgument] = "*", $relationid: [QueryArgument] = "not 1", $caseStudyCategories: [QueryArgument] = "*", $limit: Int = 12, $offset: Int = 0) {
  entryCount(
    site: $site
    section: "caseStudies"
    type: "default"
    industry: $industry
    platforms: $platforms
    region: $region
    relatedToEntries: [{id: $relationid}]
    caseStudyCategories: $caseStudyCategories
  )
  entries(
    site: $site
    section: "caseStudies"
    type: "default"
    industry: $industry
    platforms: $platforms
    region: $region
    relatedToEntries: [{id: $relationid}]
    caseStudyCategories: $caseStudyCategories
    limit: $limit
    offset: $offset
    orderBy: "postDate DESC"
  ) {
    ... on caseStudies_default_Entry {
      id
      siteId
      title
      url
      caseStudy {
        __typename
        ... on caseStudy_caseStudyPreview_BlockType {
          introTitle
        }
        ... on caseStudy_customerDetails_BlockType {
          logo @transform(height: 120, quality: 100, mode: "fit") {
            format
            width
            height
            src: url
            alt: title
            title
          }
        }
      }
      tags(limit: 2) {
        title
      }
    }
  }
}`;